import type { CategoryMeta, DeviceCategory } from "./types";

export const CATEGORY_ORDER: DeviceCategory[] = [
  "lighting",
  "sockets",
  "buildingServices",
  "emergencyLighting",
  "fireAlarm",
  "intruderAlarm",
  "data",
  "earthing",
];

export const CATEGORY_META: Record<DeviceCategory, CategoryMeta> = {
  lighting: { i18nKey: "smartSurveyor.cablesBeta.categories.lighting",
    defaultCableType: "NYM-J 3x1,5", system: "power" },
  emergencyLighting: {
    i18nKey: "smartSurveyor.cablesBeta.categories.emergencyLighting",
    defaultCableType: "NHXH-J 3x1,5 E30",
    system: "safety",
  },
  sockets: { i18nKey: "smartSurveyor.cablesBeta.categories.sockets",
    defaultCableType: "NYM-J 3x2,5", system: "power" },
  buildingServices: {
    i18nKey: "smartSurveyor.cablesBeta.categories.buildingServices",
    defaultCableType: "NYM-J 5x2,5",
    system: "power",
  },
  fireAlarm: { i18nKey: "smartSurveyor.cablesBeta.categories.fireAlarm",
    defaultCableType: "J-Y(St)Y 2x2x0,8", system: "bma" },
  intruderAlarm: {
    i18nKey: "smartSurveyor.cablesBeta.categories.intruderAlarm",
    defaultCableType: "J-Y(St)Y 4x2x0,6",
    system: "safety",
  },
  data: { i18nKey: "smartSurveyor.cablesBeta.categories.data",
    defaultCableType: "Cat.7", system: "media" },
  earthing: { i18nKey: "smartSurveyor.cablesBeta.categories.earthing",
    defaultCableType: "H07V-K 1x16", system: "earthing" },
};

/** The short code a circuit of this category is numbered with: "SB1", "L3". */
export const CATEGORY_SHORT: Record<DeviceCategory, string> = {
  lighting: "L",
  emergencyLighting: "SB",
  sockets: "S",
  buildingServices: "HT",
  fireAlarm: "BMA",
  intruderAlarm: "EMA",
  data: "D",
  earthing: "PA",
};

/** Numbering for a circuit whose category is not known. */
export const UNKNOWN_CATEGORY_SHORT = "K";

/** What a power board (main or sub) feeds unless he says otherwise. */
export const POWER_BOARD_CATEGORIES: DeviceCategory[] = ["lighting", "sockets", "buildingServices"];
